import { html } from "lit";
import { Template } from "../../../../components/slider-slide-zoomable/slider-slide-zoomable.templates";

export const HeroSliderZoomableTemplate = () => html`
    <ux-slider
        id="product-detail-page"
        arrows-follow-img
        no-arrows
        effect="fade"
    >
        ${Template({})}
        <ux-slider-pagination
            slot="pagination"
            anchor-pagination
        ></ux-slider-pagination>
    </ux-slider>
`;
